<template>
  <div>
    <!-- VEIRFY USER MODAL -->
    <div class="text-center">
      <v-dialog v-model="dialog_verify_user" max-width="500px" scrollable>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <v-card
            style="padding: 3%;"
          >
            <v-card-title>
              <v-toolbar color="white">
                <v-toolbar-title :style="{ color: parentColor }">
                  Verify User
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                  icon="mdi-close"
                  :color="parentColor"
                  @click="
                    close();
                    reset();
                  "
                ></v-btn>
              </v-toolbar>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="12" sm="12">
                  <span class="text-bold">
                    Please verify with your password to continue with signature
                  </span>
                </v-col>

                <v-col cols="12" md="12" sm="12">
                  <v-text-field
                    :rules="rules.passwordRules"
                    v-model="password"
                    :type="show ? 'text' : 'password'"
                    label="Password (Required)"
                    variant="outlined"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="primary"
                @click="
                  close();
                  reset();
                "
                variant="flat"
                elevation="1"
              >
                Close
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                :color="parentColor"
                @click="
                  verifyUserAccount();
                "
                style="float: right"
                variant="flat"
                elevation="1"
                :loading="store.loading"
              >
                Submit
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </div>
    <!-- INK SIGNATURE MODAL -->
    <ink-signature-modal
      @reset_ink_signature_modal="resetInkSignatureModal"
      :parent-color="parentColor"
    ></ink-signature-modal>
  </div>
</template>

<script>
var moment = require("moment");
import axios from "axios";
import UserData from "../repository/UserData";
import { useAuthStore } from "../../stores/auth";
import { useIndexStore } from "../../stores/index";
import { useAlertStore } from "../../stores/alert";
import GlobalMethods from "../repository/GlobalMethods";
import InkSignatureModal from "./InkSignatureModal.vue";

export default {
  name: "VerifyUserApproval",
  
  components: {
    InkSignatureModal
  },

  props: {
    parentColor: {
      type: String,
      default: 'rgb(71, 183, 83)',
      required: false,
    },
  },

  data: () => ({
    valid: false,
    dialog: false,
    interestDisclosed: "",
    interestConflict: "",
    hasConflict: false,
    confirm: false,
    comments: "",
    conditions: "",
    password: "",
    rules: {
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => (v && v.length >= 3) || "Min 3 characters",
      ],
      selectRules: [(v) => !!v || "Select is required"],
      textRules: [
        v => !!v || 'Field is required',
        v => (v && v.length >= 3) || 'Min 3 characters',
      ],
      characterRules: [
        v => (v && v.length >= 3) || 'Min 3 characters',
      ],
    },
    token: localStorage.getItem("token") ? JSON.stringify(localStorage.getItem("token")).slice(1, -1) : "",
    auth: useAuthStore(),
    store: useIndexStore(),
    alert: useAlertStore(),
    globalMethods: GlobalMethods,
    items: [],
  }),

  computed: {
    user() {
      return this.auth.getLoggedInUser;
    },

    user_ink_signatures: {
      get: function () {
        return this.store.getUserInkSignatures;
      },
      set: function (value) {
        this.store.setUserInkSignatures(value);
      }
    },

    dialog_ink_signature: {
      get: function () {
        return this.store.getDialogInkSignature;
      },
      set: function (value) {
        this.store.setDialogInkSignature(value);
      }
    },
    
    dialog_verify_user: {
      get: function () {
        return this.store.getDialogVerifyUser;
      },
      set: function (value) {
        this.store.setDialogVerifyUser(value);
      }
    },

    current_approval: {
      get: function () {
        return this.store.getCurrentApproval;
      },
      set: function (value) {
        this.store.setCurrentApproval(value);
      }
    },
  },
  
  methods: {
    resetInkSignatureModal() {
      this.dialog_ink_signature = false;

      this.$nextTick(() => {
        this.dialog_ink_signature = true;
      });
    },

    formatDate(date) {
      return moment.unix(date).format("DD MMM YYYY");
    },

    validate() {
      return this.$refs.form.validate();
    },

    resetForm() {
      return this.$refs.form.reset();
    },

    resetValidation() {
      return this.$refs.form.resetValidation();
    },

    close() {
      this.store.setDialogVerifyUser(false);
    },

    reset() {
      this.comments = "";
      this.conditions = "";
      this.password = "";
      this.interestDisclosed = "";
      this.interestConflict = "";
      this.confirm = false;
      this.hasConflict = false;
      document.querySelector('html').classList.remove('v-overlay-scroll-blocked');
    },

    getUserInkSignatures() {
      const formData = new FormData();
      formData.append("userId", UserData.getUserId() ? UserData.getUserId() : this.user.userInfo.userId);
      formData.append("companyCode", UserData.getCompanyCode() ? UserData.getCompanyCode() : this.user.companyDetail.companyCode);
      formData.append("accessToken", UserData.getAccessToken() ? UserData.getAccessToken() : this.token);
      formData.append("model", "getUserInkSignatures");
      formData.append("companyId", UserData.getCompanyId() ? UserData.getCompanyId() : this.user.companyDetail.companyId);

      this.store.setLoading(true);
      axios.post(UserData.getBaseUrl(), formData).then((response) => {
        if (response?.data?.success == 1) {
          this.$nextTick(() => {
            this.user_ink_signatures = response?.data?.data;
            this.store.setLoading(false);
          });
        } else {
          this.$nextTick(() => {
            this.store.setLoading(false);

            if (response?.data?.message) {
              this.alert.showError(response?.data?.message);
            } else {
              this.alert.showError("Failed to fetch user ink signatures.");
            }
          });
        }
      })
      .catch((e) => {
        console.log("Error", e);
      });
    },

    verifyUserAccount() {
      this.validate().then(() => {
        if (this.valid) {
          this.store.setLoading(true);
          this.globalMethods.renewTokenLease(this.password).then((response) => {
            if (response.code == 200) {
              // update approval
              this.actionType = 2;

              const formData = new FormData();
              formData.append("userId", UserData.getUserId() ? UserData.getUserId() : this.user.userInfo.userId);
              formData.append("companyCode", UserData.getCompanyCode() ? UserData.getCompanyCode() : this.user.companyDetail.companyCode);
              formData.append("accessToken", UserData.getAccessToken() ? UserData.getAccessToken() : this.token);
              formData.append("model", "verifyUser");
              formData.append("companyId", UserData.getCompanyId() ? UserData.getCompanyId() : this.user.companyDetail.companyId);
              formData.append("actionType", this.actionType == 4 ? this.radio : this.actionType);
              formData.append("password", this.password);
              formData.append("categoryId", this.current_approval.categoryId);

              axios.post(UserData.getBaseUrl(), formData).then((response) => {
                if (response?.data?.success == 1) {
                  this.$emit('approval_updated');
                  this.alert.showSuccess(response.data.message);
                  this.store.setLoading(false);
                  document.querySelector('html').classList.remove('v-overlay-scroll-blocked');
                  this.password = "";
                  this.dialog_ink_signature = true;
                  this.dialog_verify_user = false;
                  this.getUserInkSignatures();
                } else {
                  this.alert.showError(response?.data?.message);
                  this.store.setLoading(false);
                }
              })
              .catch((e) => {
                console.log("Error", e);
                this.store.setLoading(false);
              });
            } else {
              this.store.setLoading(false);
              this.alert.showError(response.response.data.message);
            }
          })
          .catch((e) => {
            this.store.setLoading(false);
            console.log("Error", e);
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.list-striped a {
  text-decoration: none;
  color: #000;
}

.list-striped a:hover {
  color: rgb(72, 61, 139);
}

.list-striped a:active {
  color: rgb(72, 61, 139);
}
</style>